/* RemixAddPhotosController.js */

import React, { useCallback, useState } from 'react';
import RemixAddPhotos from '../remix/RemixAddPhotos';
import { Button } from 'reactstrap';
import Strings from '../../translations/Translations';
import { useAuth } from '../../context/auth/AuthContext';
import { SendRemixMedia } from '../../utils/SendRemixMedia';
import { toast } from 'react-toastify';

export default function RemixAddPhotosController({ remixPars, callback }) {
  const { authenticated, toggleLoading } = useAuth();
  const [remixMedia, setRemixMedia] = useState();

  const sendMedia = useCallback(async () => {
    if (remixMedia && remixMedia.length > 0 && remixPars && remixPars.rid) {
      toggleLoading(true);
      const response = await SendRemixMedia({ al: authenticated.al, un: authenticated.un, remixMedia, rid: remixPars.rid });
      if (response.returnV) {
        toast.success(`${response.totalMedia} ${Strings('media_sent')}`);
        setRemixMedia();
        if (callback) { callback(); }
      } else {
        toast.error(Strings('an_error_ocurred_while_sending_the_media_please_try_again'));
      }
      toggleLoading(false);
    }
  }, [toggleLoading, authenticated, remixMedia, remixPars, setRemixMedia, callback]);

  return (
    <div>
      <div className='mb-3'>
        <RemixAddPhotos remixMedia={remixMedia} setRemixMedia={setRemixMedia} pickerUploadPhoto />
      </div>
      {remixMedia && remixMedia.length > 0 && (
        <Button
          className='pb-btn-1'
          size='lg'
          onClick={sendMedia}
        >
          {Strings('done_send_media')}
        </Button>
      )}
    </div>
    
  );
}
